<template>
    <div class="about">
        <header-nav></header-nav>
        <div class="content">
            <div class="type-area">
                <div class="about-content">
                    <span class="about-content-title">产品介绍</span>
                    <p class="about-content-p">雷电云手机是一款优秀的手机应用云平台，全面支持各种手机应用程序的展示、下载及应用与管理服务。并卓越实现全天候云端智能托管应用，让用户在脱离移动终端的状态下，也能将各种应用程序托管到云端，保持全天候在线。</p>
                </div>
                <div class="about-content">
                    <span class="about-content-title">公司背景</span>
                    <p class="about-content-p">广州易指网络科技有限公司，成立于2019年，是中国领先的云游戏研发企业。
                        公司一直秉承“用户至上，追求卓越”的经营理念，以“打造全球优秀的云游戏产品”为经营目标，凭借着对虚拟化技术、安卓操作系统、Linux内核等核心技术的深刻理解，凭借着对游戏行业现状和发展趋势的深刻认识，务实进取，不断创新，开创并且引领公司前行发展。 
                        公司汇集了一批来自腾讯、网易、阿里巴巴、欢聚时代等国内顶尖互联网企业的精英人士。
                        旗下主要产品雷电云手机，是一款性能强大、运行稳定的云端虚拟手机产品。
                        雷电云手机，您的24小时云端托管神器！
                    </p>
                </div>
                <div class="about-content">
                    <span class="about-content-title">联系方式</span>
                    <div class="about-content-list">
                        <div v-for="(item,idx) in contactWayList"
                             :key="idx">
                            <img :src="item.icon"
                                 alt="">
                            <p v-html="item.content"></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <footer-nav></footer-nav>
    </div>
</template>
<script>
import HeaderNav from '@/views/pc/components/header-nav.vue'
import FooterNav from '@/views/pc/components/footer-nav.vue'

export default {
	name: 'About',
	data() {
		return {
			contactWayList:[
				{
					icon: 'https://res.ldmnq.com/ldq_website/img/pc/about-site.png',
					content: '地址<br>广州市天河区中山大道西1132号汇鑫商业大厦413室'
				},
				// {
				// 	icon: 'https://res.ldmnq.com/ldq_website/img/pc/about-email.png',
				// 	content: '商务合作邮箱<br>czsw@ldmnq.com'
				// },
				{
					icon: 'https://res.ldmnq.com/ldq_website/img/pc/about-qq.png',
					content: '客服QQ<br>1081322573（群）'
				},
				{
					icon: 'https://res.ldmnq.com/ldq_website/img/pc/about-business.png',
					content: '商务QQ<br>2460396546'
				}
			]
		}
	},
	components: {
		FooterNav,
		HeaderNav
	}
}
</script>
<style lang="scss" scoped>
.about-content {
    .about-content-title {
        font-weight: bold;
        font-size: changeVw(20);
        color: #000000;
        position: relative;
        &::before {
            content: "";
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 0px;
            display: block;
            width: changeVw(52);
            height: changeVw(8);
            background: #ffcc00;
            border-radius: changeVw(4);
            z-index: -1;
        }
    }
    .about-content-p {
        margin-top: changeVw(18);
        font-size: changeVw(14);
        line-height: 40px;
        color: #333;
        opacity: 0.9;
        text-align: justify;
    }
    .about-content-list {
        display: flex;
        justify-content: space-between;
        margin: changeVw(40) 0 changeVw(100);
        div {
            padding: changeVw(36) 0;
            width: changeVw(284);
            height: changeVw(264);
            border: 1px solid #d7d7d7;
            border-radius: changeVw(16);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            p {
                line-height: changeVw(30);
                color: #333333;
                font-size: changeVw(14);
                text-align: center;
            }
            img:nth-child(1),
            img:nth-child(7) {
                width: changeVw(100);
            }
            img:nth-child(3) {
                width: changeVw(90);
            }
            img:nth-child(5) {
                width: changeVw(80);
            }
        }
    }
}
.about-content:nth-child(1) {
    margin-top: changeVw(150);
}
.about-content:nth-child(2),
.about-content:nth-child(3) {
    margin-top: changeVw(80);
}
</style>
